export const initState = {
	$list: [],
	_status: 'init',
	chunkedList: []
};

export default initState;
